import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

export type SaveEventKind = 'project' | 'scene' | 'image';

/** One entry of the append-only save journal (metadata — no snapshot). */
export interface SaveEventMeta {
	_id: string;
	path: string;
	kind: SaveEventKind;
	trigger?: string;
	userId?: string;
	createdAt: string;
	applied: boolean;
	applyError?: string;
}

/** A single changed leaf path between a save and its predecessor. */
export interface DiffEntry {
	path: string;
	before: unknown;
	after: unknown;
}

export interface SaveEventDiff {
	event: SaveEventMeta;
	hasPrevious: boolean;
	diff: DiffEntry[];
}

/** Reads the `save_events` journal for the save-history dialog. */
@Injectable({ providedIn: 'root' })
export class SaveHistoryService {
	private http = inject(HttpClient);

	list(slug: string, limit = 100): Promise<SaveEventMeta[]> {
		return firstValueFrom(
			this.http.get<{ events: SaveEventMeta[] }>(
				`${environment.apiUrl}/api/projects/${slug}/save-events`,
				{ params: { limit } },
			),
		).then((r) => r.events);
	}

	diff(slug: string, eventId: string): Promise<SaveEventDiff> {
		return firstValueFrom(
			this.http.get<SaveEventDiff>(
				`${environment.apiUrl}/api/projects/${slug}/save-events/${eventId}/diff`,
			),
		);
	}
}
